export default {
  english: {
    label: 'Read "{{ title }}" article.',
  },
  french: {
    label: 'Lisez l\'article "{{ title }}".',
  },
  arabic: {
    label: 'اقرأ المقال "{{ title }}".',
  },
  hebrew: {
    label: 'קרא "{{ title }}" כתבה',
  },
  persian: {
    label: 'مقاله "{{ title }}" را بخوانید.',
  },
}
